import AddressName from '../Components/AddressName';
import React from 'react';
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
  return {
    addressCanBuyCoinsRefrigerator: Object.values(state.addressCanBuyCoinsRefrigerator)
  };
};

const connectedAddressCanBuyCoinsRefrigerator = ({addressCanBuyCoinsRefrigerator}) => (
  <div className="c-component c-address-refrigerator">
    <h2>Adresses that can buy coins</h2>
    {addressCanBuyCoinsRefrigerator.length ? (
      <ul className="c-address-refrigerator__list">
        {addressCanBuyCoinsRefrigerator
          .filter(address => address.state)
          .map((freezeEvent) => (
            <li key={freezeEvent.address} className="c-address-refrigerator__list-item">
              <AddressName address={freezeEvent.address}/>
            </li>
          ))}
      </ul>
    ) : (
      <h4>No addresses other than owner can buy coins.</h4>
    )}
  </div>
);

const AddressCanBuyCoinsRefrigerator = connect(mapStateToProps)(connectedAddressCanBuyCoinsRefrigerator);

export default AddressCanBuyCoinsRefrigerator;


// WEBPACK FOOTER //
// ./src/components/OwnerDashboardPage/AddressCanBuyCoinsRefrigerator.js